// TOUR-6 — Ads Assistant walkthrough (log post → suggestions → dock coaching).

import type { FireflyTourArtifact } from "../tourTypes";

export const ADS_ASSISTANT_TOUR_ID = "tour-ads-assistant";

export const ADS_ASSISTANT_TOUR: FireflyTourArtifact = {
  id: ADS_ASSISTANT_TOUR_ID,
  version: 1,
  defaultIntent: "teaching",
  intents: [
    "ads assistant tour",
    "how do i use ads assistant tour",
    "give me a tour of the ads assistant",
    "can you give me a tour of the ads assistant",
    "tour of the ads assistant feature",
    "how do i log today's post",
    "log my facebook post",
    "log a facebook post",
    "social post coaching",
    "how do i log a social post",
    "show me ads assistant",
    "facebook post coaching",
  ],
  bucketRelevance: ["sales", "manager"],
  requiredRoles: ["sales"],
  requiredCapabilities: ["is_ads_runner"],
  steps: [
    {
      id: "nav-ads-assistant",
      target: { mode: "leads", anchorId: "mode-nav-adsAssistant", scrollIntoView: true },
      deferModeNavigation: true,
      skipWhenCurrentMode: "adsAssistant",
      copy: {
        title: "Open Ads Assistant",
        body: "Log today's social posts and browse coaching hints here. Tap Ads Assistant in the sidebar (or bottom bar on mobile).",
      },
      waitForClick: true,
    },
    {
      id: "ingest-tab",
      target: { mode: "adsAssistant", anchorId: "ads-ingest-tab", scrollIntoView: true },
      copy: {
        title: "Ingestion tab",
        body: "Start on Ingestion — paste your post copy, pick the platform, and optional template. This is the ~1-minute daily log path.",
      },
      waitForClick: true,
    },
    {
      id: "log-post",
      target: { mode: "adsAssistant", anchorId: "ads-log-post", scrollIntoView: true },
      copy: {
        title: "Save your post",
        body: "When the copy looks right, Save post & run analysis. Successful saves count toward your daily checklist and org activity stats.",
      },
      destructive: true,
    },
    {
      id: "suggest-tab",
      target: { mode: "adsAssistant", anchorId: "ads-suggest-tab", scrollIntoView: true },
      copy: {
        title: "Suggestion tab",
        body: "Switch to Suggestion to browse indexed posts, template stats, and coaching hints from your org's library.",
      },
      waitForClick: true,
    },
    {
      id: "activity-dock",
      target: { mode: "adsAssistant", anchorId: "activity-dock-tab", scrollIntoView: true },
      copy: {
        title: "Your Firefly tab",
        body: "Expand Firefly anytime — your ads goal tone and coaching nudges appear in the Org Activity card when something needs attention.",
      },
      advanceOn: "next_button",
    },
    {
      id: "ads-coaching",
      target: { mode: "adsAssistant", anchorId: "ads-activity-coaching", scrollIntoView: true },
      copy: {
        title: "Coaching tone",
        body: "Amber or red rings mean you are behind today's ad goal. Tap the card CTA to jump back to Ingestion or review recent posts.",
      },
      advanceOn: "next_button",
    },
    {
      id: "ask-firefly",
      target: { mode: "adsAssistant", anchorId: "ask-firefly", scrollIntoView: true },
      copy: {
        title: "Ask Firefly anytime",
        body: "Quick how-to without a full tour? Ask Firefly anytime — try lead capture or sales console tours from any Sales mode.",
      },
      advanceOn: "next_button",
    },
  ],
};
